// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/App.tsx
// Version: v2.3.0
// v2.3.0 - Adresse der Firma app.estata.com/<kurzname> (FirmLogin; statische Seiten gehen vor, Unbekanntes -> 404).
// v2.2.0 - useKeyboardViewportLock global: die Tastatur zieht die Seite nicht mehr nach oben (10.10.2026).
// Description: +AccessibilityStatement route

import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { LanguageProvider } from "./lang/index.lang.tsx";
import { useKeyboardViewportLock } from "./hooks/useKeyboardViewportLock.ts";
import ScrollToTop from "./hooks/ScrollToTop.tsx";

import "./hooks/reveal.css";

import AppLayout from "./layouts/AppLayout.tsx";
import LoginLayout from "./layouts/LoginLayout.tsx";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import About from "./pages/About.tsx";
import Careers from "./pages/Careers.tsx";
import Contact from "./pages/Contact.tsx";
import Home from "./pages/Home.tsx";
import Login from "./pages/Login.tsx";
import FirmLogin from "./pages/FirmLogin.tsx";
import NotFound from "./pages/NotFound.tsx";
import Partners from "./pages/Partners.tsx";
import Services from "./pages/Services.tsx";

// Legal Pages
import Imprint from "./pages/Imprint.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";
import TermsOfUse from "./pages/TermsOfUse.tsx";
import AccessibilityStatement from "./pages/AccessibilityStatement.tsx";

// Services
import DesignBuild from "./pages/services/DesignBuild.tsx";
import GeneralPlanning from "./pages/services/GeneralPlanning.tsx";
import ConstructionServices from "./pages/services/ConstructionServices.tsx";
import DueDiligence from "./pages/services/DueDiligence.tsx";
import EnergyAdvisory from "./pages/services/EnergyAdvisory.tsx";
import DevelopmentStrategies from "./pages/services/DevelopmentStrategies.tsx";
import FireProtection from "./pages/services/FireProtection.tsx";
import ComponentPreview from "./pages/ComponentPreview.tsx";
import Pricing from "./pages/Pricing.tsx";
import Signup from "./pages/Signup.tsx";
import VerifyEmail from "./pages/VerifyEmail.tsx";
import SaasLayout from "./layouts/SaasLayout.tsx";

const RootWrapper = () => {
  // Die Tastatur darf die Seite nicht nach oben ziehen - fuer alle Seiten (hooks/useKeyboardViewportLock).
  useKeyboardViewportLock();
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <RootWrapper />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          { index: true, element: <Home /> },
          { path: "about", element: <About /> },
          { path: "careers", element: <Careers /> },
          { path: "contact", element: <Contact /> },
          { path: "partners", element: <Partners /> },
          { path: "services", element: <Services /> },
          { path: "services/design-build", element: <DesignBuild /> },
          { path: "services/general-planning", element: <GeneralPlanning /> },
          { path: "services/construction-services", element: <ConstructionServices /> },
          { path: "services/due-diligence", element: <DueDiligence /> },
          { path: "services/energy-advisory", element: <EnergyAdvisory /> },
          { path: "services/development-strategies", element: <DevelopmentStrategies /> },
          { path: "services/fire-protection", element: <FireProtection /> },
          // Legal
          { path: "imprint", element: <Imprint /> },
          { path: "privacy-policy", element: <PrivacyPolicy /> },
          { path: "terms-of-use", element: <TermsOfUse /> },
          { path: "accessibility-statement", element: <AccessibilityStatement /> },
          { path: "*", element: <NotFound /> },
        ],
      },
      {
        path: "/login",
        element: <LoginLayout />,
        children: [{ index: true, element: <Login /> }],
      },
      {
        path: "/",
        element: <SaasLayout />,
        children: [
          { path: "pricing", element: <Pricing /> },
          { path: "signup", element: <Signup /> },
          { path: "verify-email", element: <VerifyEmail /> },
          { path: "resend-verification", element: <VerifyEmail /> },
        ],
      },
      // Adresse der Firma: app.estata.com/<kurzname> - nach allen festen Seiten (react-router nimmt Feste vor :firm)
      {
        path: "/:firm",
        element: <LoginLayout />,
        children: [{ index: true, element: <FirmLogin /> }],
      },
      {
        path: "/preview/component/:componentName",
        element: <ComponentPreview />,
      },
    ],
  },
], { future: { v7_startTransition: true, v7_relativeSplatPath: true } });

const App = () => {
  return (
    <LanguageProvider>
      <RouterProvider router={router} />
    </LanguageProvider>
  );
};

export default App;
